var last_id = Date.now()*1000;

module.exports = function() {
	var id = Date.now();
	if (id <= last_id) {
		id = last_id + 1;
	}
	last_id = id;
	return id;
};



//////////////////
// WEBPACK FOOTER
// ./lib/uniqid.js
// module id = 47
// module chunks = 0